module.exports = __webpack_public_path__ + "static/media/textediter_list.a8b0dbd5.svg";